
import { overflowContainerMixin } from '../../../mixins'
import PreprReferenceToPublicationCard from './ReferenceToPublicationCard.vue'

export default {
  name: "PreprReferenceToPublication",
  components: { PreprReferenceToPublicationCard },
  mixins: [
    overflowContainerMixin,
  ],
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model
      dataModel: {
        publication: {
          items: [],
        },
      },
    }
  },
  computed: {
    references () {
      return [...this.data.publication?.items]
    },
    overwritesCard () {
      const cardOverwrites = Object.assign({}, this.overwrites)
      delete cardOverwrites.class
      delete cardOverwrites.cols
      return cardOverwrites
    },
  },
  created () {
    this.overflowSetting = this.references.length > 1 ? 'xs:none md:8' : 'none'
  },
}
